// extracted by mini-css-extract-plugin
module.exports = {"message":"EmptyDataMessage_message__1Wdqb"};